import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { ApplyLicenseForm } from './ApplyLicenseForm';
import type { GroupEntity } from '@group/domain';
import type { License } from './LicenseDescriptionPanel';

type Props = {
  isOpen: boolean;
  onApplyCompleted(): void;
  onClose(): void;
  group: GroupEntity;
  license: License;
};

export const ApplyLicenseModal: React.FC<Props> = ({ isOpen, onApplyCompleted, onClose, group, license }: Props) => {
  return (
    <GeneralModal
      isOpen={isOpen}
      onClose={onClose}
      title={'ライセンスの申し込み'}
      submitButton={<></>}
      cancelButton={<></>}
    >
      <ApplyLicenseForm onClose={onClose} onApplyCompleted={onApplyCompleted} group={group} license={license} />
    </GeneralModal>
  );
};
